<template>
    <div class="write_box">
        <div class="write_title mb20"></div>
        <table class="Info_table">
            <tr>
                <td class="td_m_info">아이디</td>
                <td colspan="2" class="td_content">{{ memberData.mb_id }}</td>
                <td class="td_m_info">닉네임</td>
                <!--        <td colspan="2" class="td_content">{{memberData.mb_nick}}</td>-->
                <td colspan="2" class="td_content">
                    <el-input class="middle" type="text" v-model="nick" maxLength="20"
                              @input="initCheckData('nick', nick)" @blur="checkNickDuplicate()"></el-input>
                    <div class="input_error" v-if="validation.hasError('nick') && nick.length > 0">
                        {{ validation.firstError('nick') }}
                    </div>
                    <div class="input_error" v-else-if="validation.hasError('nickCheckDuplicate')">
                        {{ validation.firstError('nickCheckDuplicate') }}
                    </div>
                    <div class="input_error" v-else-if="nickCheckDuplicate">사용가능한 닉네임입니다.</div>
                </td>
            </tr>
            <tr>
                <td class="td_m_info">이름</td>
                <td colspan="2" class="td_content">{{ memberData.mb_name }}</td>
                <td class="td_m_info">생년월일</td>
                <td colspan="2" class="td_content">{{ returnDateFormat(memberData.mb_birth, 'YYYY.MM.DD') }}</td>
            </tr>
            <tr>
                <td class="td_m_info">새 비밀번호</td>
                <td colspan="2" class="td_content">
                    <el-input class="middle" type="password" v-model="password" maxLength="20"
                              @input="setPassword('password', password)"></el-input>
                    <div class="input_error" v-if="validation.hasError('password')">{{
                            validation.firstError('password')
                        }}
                    </div>
                </td>
                <td class="td_m_info">비밀번호 확인</td>
                <td colspan="2" class="td_content">
                    <el-input class="middle" type="password" v-model="passwordConfirm"
                              @input="setPassword('passwordConfirm', passwordConfirm)"></el-input>
                    <div class="input_error" v-if="validation.hasError('passwordConfirm')">
                        {{ validation.firstError('passwordConfirm') }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="td_m_info">전화번호</td>
                <td colspan="2" class="td_content">
                    <el-input class="middle" type="tel"
                              oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');"
                              v-model="phone" maxlength="11" @input="initCheckData('phone', phone)"
                              @blur="checkPhoneDuplicate()"></el-input>
                    <div class="input_error" v-show="!phone == ''" v-if="validation.hasError('phone')">
                        {{ validation.firstError('phone') }}
                    </div>
                    <div class="input_error" v-else-if="validation.hasError('phoneCheckDuplicate')">
                        {{ validation.firstError('phoneCheckDuplicate') }}
                    </div>
                    <div class="input_error" v-else-if="phoneCheckDuplicate && memberData.mb_hp != phone">사용가능한
                        전화번호입니다.
                    </div>
                </td>
                <td class="td_m_info">상태</td>
                <td colspan="2" class="td_content">{{ returnUseStatus() }}</td>
            </tr>
            <tr>
                <td class="td_m_info">프로필 썸네일</td>
                <td colspan="2" class="td_content text_center">
                    <!--          <div class="inline-block verti-middle" @click="changeType('thumbnail')">-->
                    <div class="inline-block verti-middle" @click="changeType('profile')">
                        <el-upload
                                class="avatar-uploader thumbImg mr20"
                                action=""
                                list-type="picture"
                                :show-file-list="false"
                                :auto-upload="false"
                                :on-change="onlyOneFileUpload"
                        >
                            <!--              <img v-if="checkImg('thumbnail')" :src="returnImg('thumbnail')" class="avatar">-->
                            <img v-if="checkImg('profile')" :src="returnImg('profile')" class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            <!--              <button v-if="checkImg('thumbnail')" class="cancelBtn"-->
                            <!--                      @click.stop="fileRemove(thumbnail[0], [], 'thumbnail')"></button>-->
                            <button v-if="checkImg('profile')" class="cancelBtn"
                                    @click.stop="fileRemove(profile[0], [], 'profile')"></button>
                        </el-upload>
                    </div>
                </td>
                <td class="td_m_info">프로필 배경</td>
                <td colspan="2" class="td_content text_center">
                    <div class="inline-block verti-middle" @click="changeType('background')">
                        <el-upload
                                class="avatar-uploader backImg"
                                action=""
                                list-type="picture"
                                :show-file-list="false"
                                :auto-upload="false"
                                :on-change="onlyOneFileUpload"
                        >
                            <img v-if="checkImg('background')" :src="returnImg('background')" class="avatar backImg">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            <button v-if="checkImg('background')" class="cancelBtn"
                                    @click.stop="fileRemove(background[0],[],'background')"></button>
                        </el-upload>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="td_m_info">유형</td>
                <td colspan="2" class="td_content">
                    {{ returnMemberType(memberData.mb_premium) }}
                    <el-button class="com_btn ml15" v-if="checkChangeableMember(memberData.mb_premium)"
                               @click="openModal('member-type-update-modal', memberData.mb_premium)">관리
                    </el-button>
                </td>
                <td class="td_m_info">추천인 닉네임</td>
                <td colspan="2" class="td_content">{{ returnRecommend() }}</td>
            </tr>
            <tr>
                <td class="td_m_info">큐레이터</td>
                <td colspan="2" class="td_content">
                    {{ returnCuratorStatus(memberData.g_idx) }}
                    <el-button class="com_btn ml15" v-if="checkChangeableMember(memberData.mb_premium)" @click="openModal('curator-update-modal', memberData.g_idx)">관리
                    </el-button>
                </td>
                <td class="td_m_info" v-if="checkCurator()">큐레이터 증빙자료</td>
                <td class="td_m_info" v-else></td>
                <td colspan="2" class="td_content">
                    <el-link class="mr20" type="black" v-if="checkCurator()" @click="fileDown()"
                             v-for="(data, index) in curatorFiles" :key="`memberFile${index}`">
                        {{ data.org_name }}
                    </el-link>
                    <el-link class="mr20" type="black" v-else></el-link>
                </td>
            </tr>
            <tr>
                <td class="td_m_info">계좌</td>
                <td colspan="2" class="td_content">
                    <div v-if="hasData(memberData, 'Account')">
                        {{ memberData.Account.b_name }} / {{ memberData.Account.ma_account }}
                    </div>
                </td>
                <td class="td_m_info">밍글</td>
                <td colspan="2" class="td_content">
                    {{ returnCommas(memberData.point) }} M
                    <el-button class="com_btn ml15" @click="openModal('member-mingle-update-modal')">관리</el-button>
                </td>
            </tr>
            <tr>
                <td class="td_m_info">SNS</td>
                <td colspan="4" class="td_content">
                    <el-input class="snsInput mb10" type="text" v-model="sns_1"
                              @input="initCheckData('sns_1', sns_1)"></el-input>
                    <el-input class="snsInput mb10" type="text" v-model="sns_2"
                              @input="initCheckData('sns_2', sns_2)"></el-input>
                    <el-input class="snsInput" type="text" v-model="sns_3"
                              @input="initCheckData('sns_3', sns_3)"></el-input>
                </td>
            </tr>
            <tr>
                <td class="td_m_info">자기소개</td>
                <td colspan="4" class="td_content">
                    <div class="introduce_box">
                        <el-input type="textarea" v-model="introduce"
                                  @input="initCheckData('introduce', introduce)"></el-input>
                    </div>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import memberValidator from "@/mixins/validators/memberValidator";
import util from "@/mixins/util";
import EventBus from "@/utils/event-bus";
import dateMixins from "@/mixins/dateMixins";
import {memberUseStatus} from "@/service/memberService";
import imageOption from "@/mixins/imageOption";
import elFileMixins from "@/mixins/elFileMixins";
import {memberType} from "@/service/memberService";

export default {
    name: "MemberWriteDefaultLayout",
    mixins: [memberValidator, dateMixins, elFileMixins, imageOption],
    components: {},
    inject: ['memberWriteSetData'],
    provide() {
        return {}
    },
    props: {
        memberData: {
            default: () => {
            }
        },
    },
    data() {
        return {
            curatorFiles: '',
            imageMaxSize: 20 * 1024 * 1024,
            imageSizeError: '20MB',
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
        this.setInitData();
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        onlyOneFileUpload(file, fileList) {
            let maxSize = this.imageMaxSize;
            let type = file.raw.type.split('/');

            file.name = this.regExp(file.name)
            if (file.size > maxSize) {
                this.errorAlert('1회 업로드 가능 ' + this.imageSizeError + '를 초과했습니다!');
                fileList.pop();
            } else if (!(type[1] === 'jpeg' || type[1] === 'png' || type[1] === 'gif')) {
                this.errorAlert('이미지 파일만 업로드 가능합니다.')
                fileList.pop();
            } else {
                file.org_url = file.url;
                // let idx  =file.name.lastIndexOf(".")
                // console.log(file.name.substring(idx+1))
                if (this.fileType === '' || !this.hasOwnProperty(this.fileType)) {
                    if (this.files.length > 0 && this.files[0].hasOwnProperty('a_idx') && this.files[0].a_idx != null) {
                        file.a_idx = this.files[0].a_idx;
                    }
                    this.files[0] = file;
                    this.$forceUpdate();
                    if (this.parentChange) {
                        this.parentChange('files', this.files);
                    }
                } else {
                    if (this[this.fileType].length > 0 && this[this.fileType][0].hasOwnProperty('a_idx') && this[this.fileType][0].a_idx != null) {
                        file.a_idx = this[this.fileType][0].a_idx;
                    }
                    this[this.fileType][0] = file;
                    this.$forceUpdate();
                    if (this.parentChange) {
                        this.parentChange(this.fileType, this[this.fileType]);
                    }
                }
            }
        },
        setInitData() {
            this.isRequirePassword = false;
            this.setParentData('isRequirePassword', this.isRequirePassword);
            if (!util.isEmpty(this.memberData)) {
                // console.log(this.memberData.mb_premium);
                this.premium = this.memberData.mb_premium;
                this.nick = this.memberData.mb_nick;
                this.setParentData('nick', this.nick);
                this.phone = this.memberData.mb_hp;
                this.setParentData('phone', this.phone);
                this.phoneCheckDuplicate = true;
                this.setParentData('phoneCheckDuplicate', this.phoneCheckDuplicate);
                this.phoneDuplicate = false;
                this.setParentData('phoneDuplicate', this.phoneDuplicate);
                this.sns_1 = this.memberData.mb_sns_1;
                this.setParentData('sns_1', this.sns_1);
                this.sns_2 = this.memberData.mb_sns_2;
                this.setParentData('sns_2', this.sns_2);
                this.sns_3 = this.memberData.mb_sns_3;
                this.setParentData('sns_3', this.sns_3);
                this.introduce = this.memberData.mb_introduce;
                this.setParentData('introduce', this.introduce);
                if (!util.isEmpty(this.memberData.Files) && !util.isEmpty(this.memberData.Files.Profile)) {
                    // this.memberData.File.Profile[0].url = this.memberData.Files.Profile[0].org_url;
                    this.profile = this.memberData.Files.Profile.filter(file => file.a_idx != null);
                    this.setParentData('profile', this.profile);
                }
                /*if (!util.isEmpty(this.memberData.Files) && !util.isEmpty(this.memberData.Files.ProfileThumb)) {
                    // this.memberData.File.ProfileThumb[0].url = this.memberData.Files.ProfileThumb[0].org_url;
                    this.thumbnail = this.memberData.Files.ProfileThumb;
                    this.setParentData('thumbnail', this.thumbnail);
                }*/
                if (!util.isEmpty(this.memberData.Files) && !util.isEmpty(this.memberData.Files.ProfileBack)) {
                    // this.memberData.File.ProfileBack[0].url = this.memberData.Files.ProfileBack[0].org_url;
                    this.background = this.memberData.Files.ProfileBack.filter(file => file.a_idx != null);
                    this.setParentData('background', this.background);
                }
                if (!util.isEmpty(this.memberData.Curator) && !util.isEmpty(this.memberData.Curator[0].Files)) {
                    this.curatorFiles = this.memberData.Curator[0].Files;
                }

            }
        },
        setData(type, value) {
            this[type] = value;
            this.hasError = false;
        },
        parentChange(key, value) {
            this.memberWriteSetData(key, value)
        },
        initCheckData(type, value) {
            this.setParentData(type, value);
            this[`${type}CheckDuplicate`] = false;
            this[`${type}Duplicate`] = false;
            this.$validate([`${type}CheckDuplicate`])
            this.setParentData(`${type}CheckDuplicate`, this[`${type}CheckDuplicate`]);
            this.setParentData(`${type}Duplicate`, this[`${type}Duplicate`]);
        },
        setParentData(type, value) {
            if (!util.isEmpty(this.memberWriteSetData) && util.isFunction(this.memberWriteSetData)) {
                this.memberWriteSetData(type, value);
            }
        },
        setPassword(type, value) {
            this.setParentData(type, value);
            if (this.passwordConfirm != '') {
                this.$validate([`passwordConfirm`]);
            }
        },
        checkIdAfter(type) {
            if (type === 1) {
                this.idCheckDuplicate = true;
                this.idDuplicate = false;
            } else {
                this.idCheckDuplicate = false;
                this.idDuplicate = true;
            }
            this.$validate(['idCheckDuplicate'])
            this.setParentData('idCheckDuplicate', this.idCheckDuplicate)
            this.setParentData('idDuplicate', this.idDuplicate)
        },
        checkNickAfter(type) {
            if (type === 1) {
                this.nickCheckDuplicate = true;
                this.nickDuplicate = false;
            } else {
                this.nickCheckDuplicate = false;
                this.nickDuplicate = true;
            }
            this.$validate(['nickCheckDuplicate'])
            this.setParentData('nickCheckDuplicate', this.nickCheckDuplicate)
            this.setParentData('nickDuplicate', this.nickDuplicate)
        },
        checkAllValidator() {
            this.$validate(['id', 'idCheckDuplicate', 'nick', 'nickCheckDuplicate', 'password',]);
        },
        returnDateFormat(date, format = 'YYYY-MM-DD') {
            if (!date) {
                return '';
            }
            return this.$moment(date).format(format)
        },
        returnMemberType(type) {
            if (util.isEmpty(memberType[type])) {
                return '';
            }
            return memberType[type].name;
        },
        returnUseStatus() {
            if (util.isEmpty(memberUseStatus[this.memberData.mb_is_use])) {
                return '';
            }
            return memberUseStatus[this.memberData.mb_is_use].name;
        },
        returnCuratorStatus(type) {
            switch (type) {
                case 1:
                    return '일반';
                case 2:
                    return '큐레이터';
                default:
                    return '일반';
            }
        },
        hasData(data, type) {
            return !util.isEmpty(data[type])
        },
        checkCurator() {
            // return !util.isEmpty(this.memberData.Files) && !util.isEmpty(this.memberData.Files[0].org_url) && !util.isEmpty(this.memberData.BusinessFile[0].a_idx);
            return !util.isEmpty(this.memberData.Curator);
        },
        fileDown() {
            let file = this.memberData.Files[0];
            const anchor = document.createElement('a');

            anchor.href = file.org_url;
            anchor.style.display = 'none';
            anchor.target = '_blank'
            anchor.setAttribute('download', file.org_name);
            document.body.appendChild(anchor);
            anchor.click();
        },
        checkImg(typeName) {
            if (this.hasOwnProperty(typeName) && !util.isEmpty(this[typeName])) {
                if (util.isEmpty(this[typeName][0].a_idx) && util.isEmpty(this[typeName][0].raw)) {
                    return false;
                }
                return true;
            }
        },
        checkChangeableMember(premium){
            if(premium == 2 || premium == 3){
                return false
            }
            return true
        },
        returnImg(type) {
            if (!this.checkImg(type)) {
                return '';
            }
            return util.isEmpty(this[type][0].org_url) ? this[type][0].url : this[type][0].org_url
        },
        returnCommas(x = 0) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        openModal(name, type) {
            this.$modal.show(name, type);
        },
        fileRemove(file, fileList, fileName) {
            if (file.a_idx) {
                this.deleteFiles.push(file);
                if (this.parentChange) {
                    this.parentChange('deleteFiles', this.deleteFiles);
                }
            }
            this[fileName] = fileList;
            if (this.parentChange) {
                this.parentChange(fileName, fileList);
            }
            this.$forceUpdate();
        },
        returnRecommend() {
            if (!util.isEmpty(this.memberData.Recommend)) {
                return this.memberData.Recommend[0].mb_nick;
            }else{
                return '-'
            }
        }
    },
    watch: {},
}
</script>

<style scoped>

</style>
